// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3_Qg2","col":"styles_col__esxbc","fulfillmentStatus":"styles_fulfillmentStatus__1ZRkf","emailCol":"styles_emailCol__22q40"};